module.exports = __webpack_public_path__ + "img/3.f4593fb4.png";